import { z } from "zod"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"

export const createCostBreakdownSearchSchema = (
  defaultField: GoodsReceiptSortField,
  defaultOrder: SortingOrder = SortingOrder.Asc
): z.ZodObject<{
  query: z.ZodOptional<z.ZodString>
  warehouseAreaIds: z.ZodOptional<z.ZodArray<z.ZodString>>
  isProductCostCompleted: z.ZodDefault<z.ZodOptional<z.ZodArray<z.ZodBoolean>>>
  isManagedInAs400: z.ZodDefault<z.ZodOptional<z.ZodArray<z.ZodBoolean>>>
  field: z.ZodDefault<z.ZodOptional<z.ZodNativeEnum<typeof GoodsReceiptSortField>>>
  order: z.ZodDefault<z.ZodOptional<z.ZodNativeEnum<typeof SortingOrder>>>
}> =>
  z.object({
    query: z.string().optional(),
    warehouseAreaIds: z.array(z.string()).optional(),
    isProductCostCompleted: z.array(z.boolean()).optional().default([false]),
    isManagedInAs400: z.array(z.boolean()).optional().default([false]),
    field: z.nativeEnum(GoodsReceiptSortField).optional().default(defaultField),
    order: z.nativeEnum(SortingOrder).optional().default(defaultOrder),
  })
